class FeaturedVideoCarousel extends HHBaseElement {
  constructor() {
    super()
    this._handleSlideClick = this._handleSlideClick.bind(this)
    this._handleCTAClick = this._handleCTAClick.bind(this)
  }

  connectedCallback() {
    this.attachEventListeners()
  }

  disconnectedCallback() {
    this.removeEventListeners()
  }

  attachEventListeners() {
    // Handle clicks on video slides with CTAs - prevent slideout when CTA is clicked
    const videoSlides = this.querySelectorAll('.featured-video-carousel__slider-block.js-open-slideout')

    videoSlides.forEach((slide) => {
      const ctaContainer = slide.querySelector('.featured-video-carousel__video-cta')

      if (ctaContainer) {
        ctaContainer.addEventListener('click', this._handleCTAClick)
      }
    })

    // Handle clicks on non-video slides - make entire slide clickable
    const nonVideoSlides = this.querySelectorAll('.featured-video-carousel__slider-block:not(.js-open-slideout)')
    nonVideoSlides.forEach((slide) => {
      slide.addEventListener('click', this._handleSlideClick)
    })
  }

  removeEventListeners() {
    // Remove CTA click listeners
    const videoSlides = this.querySelectorAll('.featured-video-carousel__slider-block.js-open-slideout')
    videoSlides.forEach((slide) => {
      const ctaContainer = slide.querySelector('.featured-video-carousel__video-cta')
      if (ctaContainer) {
        ctaContainer.removeEventListener('click', this._handleCTAClick)
      }
    })

    // Remove slide click listeners
    const nonVideoSlides = this.querySelectorAll('.featured-video-carousel__slider-block:not(.js-open-slideout)')
    nonVideoSlides.forEach((slide) => {
      slide.removeEventListener('click', this._handleSlideClick)
    })
  }

  _handleCTAClick(event) {
    const ctaLink = event.currentTarget.querySelector('a')

    if (ctaLink && ctaLink.href) {
      // If there's a valid link, stop propagation to prevent video from opening
      event.stopPropagation()
    } else {
      // If no link, find the parent slide and trigger its click to open video
      event.stopPropagation()
      const slide = event.currentTarget.closest('.js-open-slideout')
      if (slide) {
        slide.click()
      }
    }
  }

  _handleSlideClick(event) {
    // Don't trigger if click is already on a link or button (let them work normally)
    if (event.target.closest('a, button')) {
      return
    }

    // Find the CTA link inside this slide
    const ctaLink = event.currentTarget.querySelector('.featured-video-carousel__video-cta a')

    if (ctaLink && ctaLink.href) {
      window.location.href = ctaLink.href
    }
  }
}

window.customElements.define('featured-video-carousel', FeaturedVideoCarousel)
